import React from 'react'
import { Result } from 'antd'

const Container = () => {
  return <Result status='success' title='Successfully Registration!' />
}

export default Container
